// Importing all Services
import './DateService'
import './Module1UserManagementService'
import './UserService'
import './AuthService'
import './EnterDataService'
import './ManagerService'
import './ScanStationService'
import './ComplianceService'